var lists_default = {
  "fontElementMap": "onmxo",
  "orderedlist": "_3gwD1",
  "bulletedlist": "_7S5TO",
  "listItem": "ums8B"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
